// extracted by mini-css-extract-plugin
export default {"appLoader":"Loader_appLoader__BG23t","l2":"Loader_l2__MSIpJ"};